module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('administrador')) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.gerarRemessa
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Gerar Remessa\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade_entrada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.total_valor_entrada, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade_baixa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.total_valor_baixa, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.arquivo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.usuario.name) + " em " + _vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "href": ((_vm.$store.state.s3URI) + "/nova_garantia/remessas/" + (item.arquivo)),
        "target": "_blank",
        "download": "",
        "title": "Download"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-download",
      staticStyle: {
        "font-size": "12px"
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable,
      "limit": 5
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Remessas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Qt. Entradas")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Entradas (R$)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Qt. Baixas")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Baixas (R$)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Arquivo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Gerado por")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59116704"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operacao/remessas/index.vue
// module id = 399
// module chunks = 1